export class HttpStatus {
  public static readonly OK: number = 200;
  public static readonly NOT_FOUND: number = 404;
  public static readonly BAD_REQUEST: number = 400;
  public static readonly NO_CONTENT: number = 204;
  public static readonly INTERNAL_SERVER_ERROR: number = 500;
  public static readonly REDIRECT = 302;
}
